import { createSlice } from "@reduxjs/toolkit";
import {
  setLanguage,
  setPlatform,
  setDevice,
  setSourceDevice,
  setProduct,
  setShowHeader,
  get_req,
} from "../Utilities/apiUtil";
import { payment_link_request_url } from "../Utilities/apiUrl";
import appConst from "../Utilities/appConst.json";
import { basketActions } from "./basket";
import { errorActions } from "./errorSlice";
import {
  getLanguageDirection,
  normalizeLanguageCode,
} from "../Utilities/languageDirection";

export const payment_link = (ordertoken) => {
  return async (dispatch) => {
    try {
      const data = await get_req(
        `${payment_link_request_url}&ordertoken=${ordertoken}`
      );
      if (data.payload.isValid) {
        dispatch(errorActions.setError(true));
      }
      if (data && data.payload) {
        dispatch(basketActions.setIFrameURL(data.payload.url));
      }
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

const modeSlice = createSlice({
  name: "mode",
  initialState: {
    product: "",
    language: "he",
    direction: getLanguageDirection("he"),
    platform: "",
    device: "",
    sourceDevice: "",
    showHeader: "true",
    valueGA4: [],
    isSentEventGA4: false,
    quary: "",
    path: "",
  },
  reducers: {
    setProduct: (state, action) => {
      if (action.payload) {
        try {
          sessionStorage.setItem(appConst.PRODUCT, action.payload);
        } catch (err) {
          console.log(err);
        }
        state.product = action.payload;
        setProduct(action.payload);
      }
    },
    setLaguage: (state, action) => {
      const normalizedLanguage = normalizeLanguageCode(action.payload);
      if (normalizedLanguage) {
        try {
          sessionStorage.setItem(appConst.LANGUAGE, normalizedLanguage);
          // Also in localStorage: sessionStorage is per-tab, and links like /addpay
          // open in a fresh tab with no query param.
          localStorage.setItem(appConst.LANGUAGE, normalizedLanguage);
        } catch (err) {
          console.log(err);
        }
        state.language = normalizedLanguage;
        state.direction = getLanguageDirection(normalizedLanguage);
        setLanguage(normalizedLanguage);
      }
    },
    setPlatform: (state, action) => {
      if (action.payload) {
        try {
          sessionStorage.setItem(appConst.PLATFORM, action.payload);
        } catch (err) {
          console.log(err);
        }
        state.platform = action.payload;
        setPlatform(action.payload);
      }
    },
    setDevice: (state, action) => {
      if (action.payload) {
        try {
          sessionStorage.setItem(appConst.DEVICE, action.payload);
        } catch (err) {
          console.log(err);
        }
        state.device = action.payload;
        setDevice(action.payload);
      }
    },
    setSourceDevice: (state, action) => {
      if (action.payload) {
        try {
          sessionStorage.setItem(appConst.SOURCE_DEVICE, action.payload);
        } catch (err) {
          console.log(err);
        }
        state.sourceDevice = action.payload;
        setSourceDevice(action.payload);
      }
    },
    setShowHeader: (state, action) => {
      if (action.payload != null) {
        try {
          sessionStorage.setItem(appConst.SHOW_HEADER, action.payload);
        } catch (err) {
          console.log(err);
        }
        state.showHeader = action.payload;
        setShowHeader(action.payload);
      }
    },
    setValueGA4: (state, action) => {
      if (!state.valueGA4.includes(action.payload)) {
        state.valueGA4.push(action.payload);
      }
    },
    popValueGA4: (state, action) => {
      state.valueGA4.pop();
    },
    setIsSentEventGA4: (state, action) => {
      state.isSentEventGA4 = action.payload;
    },
    setQuary: (state, action) => {
      state.quary = action.payload;
    },
    setPath: (state, action) => {
      state.path = action.payload;
    },
  },
});

export const modeActions = modeSlice.actions;
export default modeSlice;
